"use strict";

var _slicedToArray = require("/codebuild/output/src073659321/src/turo-project/turo-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var getBlockOffset_1 = __importDefault(require("../query/getBlockOffset"));

var utils_1 = require("../utils");

var getFragmentNode_1 = __importDefault(require("./getFragmentNode"));

exports.default = function (listState) {
  var domSelection = window.getSelection();

  if (domSelection == null || domSelection.anchorNode == null) {
    return null;
  }

  var anchorOffset = domSelection.anchorOffset,
      focusOffset = domSelection.focusOffset;
  var _anchorNode = domSelection.anchorNode;
  var _focusNode = domSelection.focusNode;
  var anchorNode = getFragmentNode_1.default(_anchorNode);
  var focusNode = getFragmentNode_1.default(_focusNode);

  if (anchorNode != null && focusNode != null) {
    anchorOffset = utils_1.getUTF16Length(anchorNode.innerText.slice(0, anchorOffset));
    focusOffset = utils_1.getUTF16Length(focusNode.innerText.slice(0, focusOffset));
  }

  if (anchorNode == null || focusNode == null) {
    return null;
  }

  var anchorKey = anchorNode.dataset.blockKey;
  var focusKey = focusNode.dataset.blockKey;
  var anchorFragmentOffset = parseInt(anchorNode.dataset.fragmentStart);
  var focusFragmentOffset = parseInt(focusNode.dataset.fragmentStart);
  anchorOffset += (getBlockOffset_1.default(listState, anchorKey) || 0) + anchorFragmentOffset;
  focusOffset += (getBlockOffset_1.default(listState, focusKey) || 0) + focusFragmentOffset;

  var _sort = [anchorOffset, focusOffset].sort(function (a, b) {
    return a - b;
  }),
      _sort2 = _slicedToArray(_sort, 2),
      start = _sort2[0],
      end = _sort2[1];

  return {
    start: start,
    end: end,
    anchorOffset: anchorOffset,
    focusOffset: focusOffset
  };
};